<template>
  <div id="app">
    <default>
      <router-view/>
    </default>
  </div>
</template>

<script>
import Default from '@/views/Layouts/Default/Default.vue';

export default {
  metaInfo() {
    const title = this.$t('GENIKES_INSURANCE');
    const generalTitle = this.$t('GIC');
    return {
      title,
      // if no subcomponents specify a metaInfo.title, this title will be used
      // all titles will be injected into this template
      titleTemplate: (title) => `${title} | ${generalTitle}`,
      meta: [
        {
          property: 'og:title',
          content: title,
          // following template options are identical
          // template: '%s - My page',
          template: (title) => `${title} | ${generalTitle}`,
          vmid: 'og:title'
        },
        {
          property: 'twitter:title',
          content: title,
          // following template options are identical
          // template: '%s - My page',
          template: (title) => `${title} | ${generalTitle}`,
          vmid: 'twitter:title'
        }
      ]
    };
  },
  components: {
    Default,
  }
};
</script>

<style lang="scss">
  @import "@/assets/styles/index.scss";
</style>
